import React from 'react';
import { GENDER } from 'src/constants';
import {
  convertClientDateToServerDate,
  formatDateToDayShortWithYear,
  getAge,
} from 'src/utils/dateUtils';
import { pluralizeYears } from 'src/utils/pluralizeUtils';
import styled from 'styled-components';
import { parse } from 'date-fns';
import type { GENDER as GENDER_TYPE } from '@lt/api/dist/types/tourists';
import { TEST_ID_TOURIST_INITIALS } from './constants';

type Props = {
  birthday: string;
  name: string;
  surname: string;
  passport_number: string;
  gender: GENDER_TYPE;
};

const TouristInfo = ({
  birthday,
  name,
  surname,
  passport_number,
  gender,
}: Props) => {
  const birthdayInClientFormat = convertClientDateToServerDate(birthday);

  const birthdayFormatted = formatDateToDayShortWithYear(
    birthdayInClientFormat,
  );

  const birthdayDate = parse(birthday, 'dd.MM.yyyy', new Date());
  const age = getAge(birthdayDate);

  return (
    <>
      <GenderContainer>
        <GenderIndicator $gender={gender} />
      </GenderContainer>
      <div>
        <TouristInitials data-testid={TEST_ID_TOURIST_INITIALS}>
          {name} {surname}
        </TouristInitials>
        <AdditionalInfo>
          {`${age} ${pluralizeYears(age)}`} · {birthdayFormatted} ·{' '}
          {passport_number}
        </AdditionalInfo>
      </div>
    </>
  );
};

const GenderContainer = styled.div`
  margin-right: 8px;
`;

const GenderIndicator = styled.div<{ $gender?: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;

  ${(props) => props.$gender === GENDER.MALE && `background-color: #4a90e2`};
  ${(props) => props.$gender === GENDER.FEMALE && `background-color: #e568b2`};
`;

const AdditionalInfo = styled.div`
  color: #4d4d4d;
`;

const TouristInitials = styled.div`
  font-weight: 700;
`;

export default TouristInfo;
